import React, { useContext, useEffect } from 'react';
import AsideMenu from '../menu-components/AsideMenu';
import NavBarMenu from '../menu-components/NavBarMenu';
import SectionContext from './SectionContext';

const AdminLayout = ({ children, unsavedChanges = false }) => {
    const setDirty = useContext(SectionContext);
    useEffect(() => {
        if (!setDirty) return undefined;
        setDirty(Boolean(unsavedChanges));
        return () => setDirty(false);
    }, [setDirty, unsavedChanges]);
    if (setDirty) return <>{children}</>;
    return (
    <div className="flex min-h-screen bg-admin-canvas">
        <AsideMenu />
        <div className="flex min-w-0 flex-1 flex-col">
            <NavBarMenu />
            <main className="flex-1 p-4 md:p-8">{children}</main>
        </div>
    </div>
    );
};

export default AdminLayout;
